import { create } from 'zustand';
import { Account, AccountWithBalance } from '../types/api';

interface AccountsState {
  accounts: AccountWithBalance[];
  selectedAccount: Account | null;
  isLoading: boolean;
  error: string | null;
}

interface AccountsActions {
  setAccounts: (accounts: AccountWithBalance[]) => void;
  setSelectedAccount: (account: Account | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  addAccount: (account: AccountWithBalance) => void;
  updateAccount: (accountId: string, updates: Partial<AccountWithBalance>) => void;
  removeAccount: (accountId: string) => void;
  clearError: () => void;
  reset: () => void;
}

type AccountsStore = AccountsState & AccountsActions;

const initialState: AccountsState = {
  accounts: [],
  selectedAccount: null,
  isLoading: false,
  error: null,
};

export const useAccountsStore = create<AccountsStore>((set, get) => ({
  ...initialState,

  // State setters
  setAccounts: (accounts) => set({ accounts }),
  setSelectedAccount: (selectedAccount) => set({ selectedAccount }),
  setLoading: (isLoading) => set({ isLoading }),
  setError: (error) => set({ error }),
  
  // Account operations
  addAccount: (account) => set((state) => ({
    accounts: [...state.accounts, account]
  })),
  
  updateAccount: (accountId, updates) => set((state) => ({
    accounts: state.accounts.map(account =>
      account.id === accountId ? { ...account, ...updates } : account
    )
  })),
  
  removeAccount: (accountId) => set((state) => ({
    accounts: state.accounts.filter(account => account.id !== accountId),
    selectedAccount: state.selectedAccount?.id === accountId ? null : state.selectedAccount
  })),
  
  // Utility actions
  clearError: () => set({ error: null }),
  reset: () => set(initialState),
}));